module.exports = __webpack_public_path__ + "img/UP380C&BT4.pic.91d87efe.png";